import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const columns = [
  {
    title: "浏览事件库",
    links: [
      { label: "最新整理", to: "/events" },
      { label: "按热度排行", to: "/events?sort=heat" },
      { label: "娱乐八卦", to: "/events?category=娱乐八卦" },
      { label: "影视热剧", to: "/events?category=影视热剧" },
    ],
  },
  {
    title: "热门合集",
    links: [
      { label: "音乐现场合集", to: "/events?category=音乐现场" },
      { label: "综艺观察盘点", to: "/events?category=综艺观察" },
      { label: "网红动态列表", to: "/events?category=网红动态" },
      { label: "品牌公关复盘", to: "/events?category=品牌公关" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "网站定位", to: "/about" },
      { label: "内容原则", to: "/about#principles" },
      { label: "整理历程", to: "/about#history" },
      { label: "常见问题", to: "/#faq" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-accent-950 text-background-50">
      <div className="w-full px-4 md:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-plant-line text-lg" />
              </span>
              <span className="font-heading text-xl font-bold">{siteInfo.name}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">{siteInfo.description}</p>
            <a
              href={`mailto:${siteInfo.email}`}
              rel="nofollow"
              className="mt-5 inline-flex items-center gap-2 text-sm text-secondary-300 hover:text-secondary-200"
            >
              <i className="ri-mail-line" />
              {siteInfo.email}
            </a>
            <p className="mt-2 flex items-center gap-2 text-sm text-background-300">
              <i className="ri-time-line" />
              {siteInfo.workingHours}
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold tracking-wide text-secondary-300">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-sm text-background-200 transition-colors hover:text-primary-300">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-accent-900 pt-6 md:flex-row md:items-center">
          <p className="text-xs text-background-300">
            © 2026 {siteInfo.name} · 内容为公开信息整理，仅作事件脉络记录
          </p>
          <p className="text-xs text-background-300">
            站内热度为相对参考值，不代表真实统计口径
          </p>
        </div>
      </div>
    </footer>
  );
}